var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-4h24v24H-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7H3.85l4.888-4.887A.99.99 0 008.725.7a1.026 1.026 0 00-1.438.013L.566 7.434a.8.8 0 000 1.132L7.3 15.3a.99.99 0 001.4 0 .994.994 0 00.003-1.403L3.85 9H15a1 1 0 000-2z",
    fill: "#051D39"
  }))));
}

export default SvgBackArrow;